<template>
    <v-dialog v-model="dialog" max-width="1200">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>Transaction Details</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-tabs slider-color="grey" v-model="activeTab">
                <v-tab ripple>Transaction</v-tab>
                <v-tab v-if="(transaction.paymentType == 'DB' || transaction.paymentType == 'PA' || transaction.paymentType == 'SD') && transaction.status >= 1" ripple>Actions</v-tab>
                <v-tab ripple>Payload</v-tab>

                <v-tab-item>
                    <v-container fluid grid-list-md class="transaction-tab">
                    <v-data-iterator :items="transactionArray" content-tag="v-layout" row wrap hide-actions>
                        <template v-slot:item="props">
                            
                            <v-flex xs6>
                            <v-hover>
                                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 1}`">
                                    <v-list dense>
                                        <v-card-title class="primary white--text"><b>Transaction Information</b></v-card-title>
                                        <v-divider></v-divider>
                                        <v-list-tile v-if="props.item.amount">
                                            <v-list-tile-content class="font-weight-bold">Amount:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.amount }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.cardExpDate">
                                            <v-list-tile-content class="font-weight-bold">Card Expiry:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.cardExpDate }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Card Holder:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.cardHolder }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="!props.item.cardNumber.includes('null')">
                                            <v-list-tile-content class="font-weight-bold">Card Number:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.cardNumber }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.currency">
                                            <v-list-tile-content class="font-weight-bold">Currency:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.currency }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Date:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.date }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.merchantTransactionId">
                                            <v-list-tile-content class="font-weight-bold">Merchant Transaction ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.merchantTransactionId }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.paymentBrand">
                                            <v-list-tile-content class="font-weight-bold">Payment Brand:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.paymentBrand }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Payment Type:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.paymentType }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.recurringType">
                                            <v-list-tile-content class="font-weight-bold">Recurring Type:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.recurringType }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Status Description:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.status_desc }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Status Code:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.code }}</v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-hover>
                            </v-flex>
                            
                            <v-flex xs6>
                            <v-hover>
                                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 1}`">
                                    <v-list dense>
                                        <v-card-title class="primary white--text"><b>Gateway Information</b></v-card-title>
                                        <v-divider></v-divider>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Channel ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.channelId }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Channel Name:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ channelName }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.clearingInstitute">
                                            <v-list-tile-content class="font-weight-bold">Clearing Institute:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.clearingInstitute }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">DB ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.id }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Merchant Name:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.merchantName }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">UUID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.uuid }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.paymentType == 'RF'">
                                            <v-list-tile-content class="font-weight-bold">Reference ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.referenceId }}</v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-hover>
                            </v-flex>
                        </template>
                    </v-data-iterator>
                    </v-container>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false">Ok</v-btn>
                    </v-card-actions>
                </v-tab-item>
                
                <v-tab-item v-if="(transaction.paymentType == 'DB' || transaction.paymentType == 'PA' || transaction.paymentType == 'SD') && transaction.status >= 1">
                    <v-flex v-if="transaction.paymentType != 'SD'" xs3 class="pr-5">
                        <v-card-text class="text-sm-left">
                        <div>
                            <v-text-field class="refund-amount" type="number" v-model="transaction.refundAmount" label="Amount"></v-text-field>
                        </div>
                        </v-card-text>
                    </v-flex>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="(transaction.paymentType == 'DB')" color="error" @click="refund()">Refund</v-btn>
                        <v-btn color="primary" @click="dialog = false">Ok</v-btn>
                    </v-card-actions>
                </v-tab-item>
            
                <v-tab-item>
                    <v-card-text class="text-sm-left">
                        <pre>{{ payload }}</pre>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false">Ok</v-btn>
                    </v-card-actions>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </v-dialog>
</template>

<script>
    import sweetAlert from '../sweetAlert.js';
    import axios from 'axios';

    export default {
        data() {
            return {
                transaction: {},
                transactionArray: [],
                activeTab: 0,
                tableHeaders: [{ text: 'Status', value: 'status', sortable: false, align: 'center' },
                               { text: 'Date', value: 'date', sortable: false, align: 'left' },
                               { text: 'Payment Type', value: 'paymentType', sortable: false, align: 'left' },
                               { text: 'Amount', value: 'amount', sortable: false, align: 'left' },
                               { text: 'Currency', value: 'currency', sortable: false, align: 'left' },
                               { text: 'Status', value: 'status', sortable: false, align: 'left' }],
                payloadData: null,
                currentDatetime: (new Date()).toISOString().slice(0, 19).replace("T", " "),
                delay: 4000
            }
        },
        mixins: [ sweetAlert ],
        props: {
            visible: Boolean,
            tranInfo: Object
        },
        computed: {
            dialog: {
                get() {
                    if(this.visible) {
                        console.log(this.tranInfo);
                        this.transaction.amount = this.tranInfo.amount;
                        this.transaction.cardExpDate = this.tranInfo.expDate;
                        this.transaction.cardHolder = this.tranInfo.holder;
                        this.transaction.cardNumber = this.tranInfo.bin + '******' + this.tranInfo.last4Digits;
                        this.transaction.channelId = this.tranInfo.entityId;
                        this.transaction.clearingInstitute = this.tranInfo.clearingInstituteName;
                        this.transaction.code = this.tranInfo.code;
                        this.transaction.currency = this.tranInfo.currency;
                        this.transaction.date = this.tranInfo.processing_time;
                        this.transaction.id = this.tranInfo.id;
                        this.transaction.merchantName = 'Enhance You Ltd';
                        this.transaction.merchantTransactionId = this.tranInfo.merchantTransactionId;
                        this.transaction.paymentBrand = this.tranInfo.paymentBrand;
                        this.transaction.paymentType= this.tranInfo.paymentType;
                        this.transaction.recurringType = this.tranInfo.recurringType;
                        this.transaction.referenceId = (JSON.parse(this.tranInfo.responseData).payload || {}).referencedId || null;
                        this.transaction.refundAmount = this.tranInfo.amount;
                        this.transaction.status = this.tranInfo.status;
                        this.transaction.status_desc = JSON.parse(this.tranInfo.responseData).payload.result.description ? JSON.parse(this.tranInfo.responseData).payload.result.description : '';
                        this.transaction.uuid = this.tranInfo.uniqueId;
                        this.payloadData = this.tranInfo.responseData;
                        this.transactionArray[0] = this.transaction;
                        console.log(JSON.parse(this.tranInfo.responseData).payload.referenceId);
                    }
                    return this.visible;
                },
                set(value) {
                    if(!value) {
                        this.activeTab = 0;
                        this.$emit('closeDialog');
                    }
                }
            },
            payload: function() {
                return JSON.parse(this.payloadData);
            },
            channelName: function() {
                if(this.tranInfo.entityId = '8ac9a4c866ab213b0166b13802d320a0') {
                    return 'Ketoslim Discount';
                }
                else if(this.tranInfo.entityId = '8ac9a4c866ab213b0166b121dffd203d') {
                    return 'Instasmooth';
                }
                else if(this.tranInfo.entityId = '8ac9a4c866ab213b0166b12738612057') {
                    return 'Instaslim Discount';
                }
                else if(this.tranInfo.entityId = '8ac9a4c866ab213b0166b122dde32041') {
                    return 'Instalift';
                }
                else if(this.tranInfo.entityId = '8ac9a4c866ab213b0166b1262ada204e') {
                    return 'Instacleanse Discount';
                }
                else if(this.tranInfo.entityId = '8ac9a4ca692f2ddb0169363ce10e2622') {
                    return 'SecureTrading - Merchant Account #1';
                }
                else if(this.tranInfo.entityId = '8ac9a4ca692f2ddb0169363d3fac2627') {
                    return 'SecureTrading - Merchant Account #2';
                }
            }
        },
        methods: {
            refund() {
                axios({
                    method: 'post',
                    url: 'https://controlapi.totalprocessing.com/api/refund-alto',
                    data: { transaction: this.tranInfo, refundAmount: this.transaction.refundAmount },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        this.sweetAlert(response.data);
                        setTimeout(() => {
                            this.$emit('getTransactions');
                        }, this.delay);
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            },
            reversal() {
                axios({
                    method: 'post',
                    url: 'https://controlapi.totalprocessing.com/api/reversal',
                    data: { transaction: this.tranInfo },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        this.sweetAlert(response.data);
                        setTimeout(() => {
                            this.$emit('getTransactions');
                        }, this.delay);
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            },
            capture() {
                axios({
                    method: 'post',
                    url: 'https://controlapi.totalprocessing.com/api/capture',
                    data: { transaction: this.tranInfo },
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        this.sweetAlert(response.data);
                        setTimeout(() => {
                            this.$emit('getTransactions');
                        }, this.delay);
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            }
        }
    }
</script>